import type { SessionMetadata } from "@app/analytics/MeetingReport/types";
import * as ShareUtils from "@app/common/access/ShareReport/utils";
import type { EntityAccessLevel } from "@app/common/types";

export const showParticipants = ({
  acl,
  numParticipants,
  sessionMetadata,
}: {
  acl: EntityAccessLevel;
  numParticipants: number;
  sessionMetadata: SessionMetadata;
}) => {
  return (
    numParticipants > 0 &&
    !(
      sessionMetadata.isNotetakerReport ||
      sessionMetadata.isProcessing ||
      sessionMetadata.dataDeleted ||
      ShareUtils.hasRecapOnlyAccess(acl)
    )
  );
};

export const showTags = ({
  sessionMetadata,
}: {
  sessionMetadata: SessionMetadata;
}) => {
  return !sessionMetadata.isProcessing;
};

export const showDownloadMenu = ({
  canDownload,
  sessionMetadata,
}: {
  canDownload: boolean;
  sessionMetadata: SessionMetadata;
}) => {
  return canDownload && !sessionMetadata.isProcessing;
};
